<template>
  <nav
    class="bottom-nav flex-center fixed bottom-0 left-0 right-0 pb-safe h-14 text-center text-text-secondary bg-background-2"
    role="navigation"
  >
    <router-link to="/" :class="itemClass" exact-active-class="active">
      <HomeIcon class="size-6 mx-auto mb-0.5" />
      首页
    </router-link>
    <router-link to="/trade" :class="[itemClass, { active: isTradeActive }]">
      <TradeIcon class="size-6 mx-auto mb-0.5" />
      买卖币
    </router-link>
    <router-link to="/orders" :class="itemClass" active-class="active">
      <OrderIcon class="size-6 mx-auto mb-0.5" />
      订单
      <span
        v-if="hasUnreadOrders"
        class="unread-dot size-1.5 absolute top-0 left-1/2 translate-x-2 bg-auxiliary-red rounded-full"
      ></span>
    </router-link>
    <router-link to="/profile" :class="itemClass" active-class="active">
      <ProfileIcon class="size-6 mx-auto mb-0.5" />
      我的
    </router-link>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import HomeIcon from '@/svg/nav/index.svg'
import TradeIcon from '@/svg/nav/trade.svg'
import OrderIcon from '@/svg/nav/order.svg'
import ProfileIcon from '@/svg/nav/profile.svg'
import { useNotifyStore } from '@/stores/notify'

const route = useRoute()
const itemClass = 'nav-item flex-1 flex-center flex-col  text-xs relative'
const notifyStore = useNotifyStore()
const hasUnreadOrders = computed(() => {
  return Number(notifyStore.notifyData?.tab_order.unread) > 0
})
const isTradeActive = computed(() => {
  return route.path === '/trade' || route.path === '/sell-coin'
})
</script>

<style scoped>
.nav-item {
  color: var(--color-text-secondary);
}
.nav-item.active {
  color: var(--color-primary) !important;
  font-weight: 600;
}
</style>
